<template>
  <v-btn color="primary" small tile outlined @click="exportToCsv" class="mx-2"
    ><v-icon small color="primary">mdi-file-export-outline</v-icon>
    Export To Csv
  </v-btn>
</template>

<script>
export default {
  props: ["headers", "items", "fileName"],
  methods: {
    exportToCsv() {
      // 1. Prepare the CSV header row
      const csvHeader = this.headers.map((header) => header.text).join(",");

      // 2. Prepare the CSV data rows
      const csvRows = this.items.map((item) => {
        return this.headers
          .map((header) => {
            let value = item[header.value]; // Get the value from the item using the header's value
            if (typeof value === "string") {
              // Escape commas and quotes if present in the string
              value = `"${value.replace(/"/g, '""')}"`;
            }
            return value;
          })
          .join(",");
      });

      // 3. Combine header and rows
      const csvContent = [csvHeader, ...csvRows].join("\n");

      // 4. Create a Blob and trigger download
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      if (link.download !== undefined) {
        // Feature detection for download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", this.fileName);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        // Fallback for browsers that don't support the download attribute
        alert(
          "Your browser does not support automatic downloads. Please copy the data manually."
        );
      }
    },
  },
};
</script>

<style></style>
